import type { ResearchStep } from './MessageResearch';

export const getLastStepOrder: (steps: ResearchStep[]) => number = (steps) => {
	return steps.length ? Math.max(...steps.map((step) => step.order)) : 0;
};
